// extracted by mini-css-extract-plugin
export default {"commissionSplitsViewContainer":"commissionSplits_commissionSplitsViewContainer__aNbFP","header":"commissionSplits_header__5jPsN"};